export default serviceClient => {
  return {
    async retrieveDisplayConditions({commit, rootState}, {sourceId, page = 0}) {
      try {
        const result = await serviceClient.getDisplayConditions(
          rootState.accessToken,
          rootState.customer,
          sourceId,
          {page}
        );
        commit('setDisplayConditions', result.content);
        commit('setPageCount', result.totalPages);
        commit('setCurrentPage', result.number + 1);
      } catch (error) {
        commit('setError', error, {root: true});
      }
    },
    async retrieveSourceFields({commit, rootState}, {sourceId, page = 0}) {
      try {
        let currentPage = page;
        let result;
        let fields = [];
        do {
          result = await serviceClient.getSourceFields(
            rootState.accessToken,
            rootState.customer,
            sourceId,
            {page: currentPage}
          );
          currentPage++;
          fields = fields.concat(result.content);
        } while (result.last === false);
        commit('setFields', fields);
        commit('resetValues');
      } catch (error) {
        commit('setError', error, {root: true});
      }
    },
    async retrieveSourceFieldValues(
      {commit, rootState},
      {sourceId, field, page = 0}
    ) {
      try {
        const result = await serviceClient.getSourceFieldValues(
          rootState.accessToken,
          rootState.customer,
          sourceId,
          field,
          {page}
        );
        commit('setValues', {field, values: result.content});
      } catch (error) {
        commit('setError', error, {root: true});
      }
    },
    async saveDisplayCondition(
      {rootState, commit},
      {mergeTagsSource, condition}
    ) {
      try {
        const result = await serviceClient.saveDisplayCondition(
          rootState.accessToken,
          rootState.customer,
          mergeTagsSource,
          condition
        );
        commit('pushNewDisplayCondition', result);
      } catch (error) {
        commit('setError', error, {root: true});
      }
    },
    async updateDisplayCondition(
      {rootState, commit, dispatch},
      {mergeTagsSource, conditionId, condition}
    ) {
      try {
        await serviceClient.updateDisplayCondition(
          rootState.accessToken,
          rootState.customer,
          mergeTagsSource,
          conditionId,
          condition
        );
        dispatch('retrieveDisplayConditions', {sourceId: mergeTagsSource});
      } catch (error) {
        commit('setError', error, {root: true});
      }
    },
    async deleteDisplayCondition(
      {rootState, commit, dispatch},
      {mergeTagsSource, conditionId}
    ) {
      try {
        await serviceClient.deleteDisplayCondition(
          rootState.accessToken,
          rootState.customer,
          mergeTagsSource,
          conditionId
        );
        commit('setConditionToDelete', undefined);
        dispatch('retrieveDisplayConditions', {sourceId: mergeTagsSource});
      } catch (error) {
        commit('setError', error, {root: true});
      }
    }
  };
};
